/** Espelha acao_etapa (db_compras) e `AcaoEtapaEnum` da API Compras: ações da matriz de permissões por perfil da etapa. */
export enum AcaoEtapaEnum {
  Visualizar = 1,
  Editar = 2,
  Cancelar = 3,
  ConferirVolumes = 4,
  ConferirItens = 5,
  ConferirProblemas = 6,
  AlterarSituacaoManualmente = 7,
}
